export default __webpack_public_path__ + "static/Bildschirmfoto-2019-11-08-um-14.34.16-e9b39600fe39de3cbb2b9a65e8868106.jpg";